import { render, staticRenderFns } from "./ViqReportBriefing.vue?vue&type=template&id=17e1f084&scoped=true"
import script from "./ViqReportBriefing.vue?vue&type=script&lang=js"
export * from "./ViqReportBriefing.vue?vue&type=script&lang=js"
import style0 from "./ViqReportBriefing.vue?vue&type=style&index=0&id=17e1f084&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e1f084",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17e1f084')) {
      api.createRecord('17e1f084', component.options)
    } else {
      api.reload('17e1f084', component.options)
    }
    module.hot.accept("./ViqReportBriefing.vue?vue&type=template&id=17e1f084&scoped=true", function () {
      api.rerender('17e1f084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqReportBriefing.vue"
export default component.exports